<template>
    <div :class="className" v-if="summary.childrenCount > 0">
        <div class="progress_bar_label">{{ notInThePlanValue + '/' + summary.childrenCount }}</div>
        <b-progress height="44px" :max="summary.childrenCount">
            <b-progress-bar :value="summary.childrenCompleteCount" class="sts_blc_Cmplt"></b-progress-bar>
            <b-progress-bar :value="summary.childrenInProgressCount" class="sts_blc_Prgs"></b-progress-bar>
            <b-progress-bar :value="summary.childrenFailedCount" class="sts_blc_Fail"></b-progress-bar>
            <b-progress-bar :value="inThePlanValue" class="sts_blc_InPlan"></b-progress-bar>
        </b-progress>
    </div>
    <div class="competency_progress" v-else>
        <!--<div class="progress_bar_label">N/A</div>-->
        <b-progress height="44px" :max="1">
            <b-progress-bar :value="1" :class="statusClass"></b-progress-bar>
        </b-progress>
    </div>
</template>

<script>
    export default {
      name: 'competencySummaryProgressBar',
      props: ['summary', 'className'],
      data: () => {
        return {
          status_css: {0: 'sts_blc_InPlan', 1: 'sts_blc_Prgs', 2: 'sts_blc_Cmplt', 3: 'sts_blc_Fail'}
        }
      },

      computed: {
        notInThePlanValue: function () {
          return this.summary.childrenCompleteCount + this.summary.childrenInProgressCount + this.summary.childrenFailedCount
        },

        inThePlanValue: function () {
          return this.summary.childrenCount - this.notInThePlanValue
        },

        statusClass: function () {
          const status = this.summary.status
          return this.status_css[status]
        }
      }
    }
</script>

<style scoped>
    .competency_progress {
        width: 96px;
        position: absolute;
        margin: auto;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 44px;
    }

    .progress_bar_label {
        position: absolute;
        margin: auto;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        text-align: center;
        height: 22px;
        font-size: 14px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/CompetencySummaryProgressBar.vue